import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { resources as EmailGroups } from "./EmailGroups";
import { resources as SentEmails } from "./SentEmails";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU, tenants.MGU],
  icon: <NotificationsActiveIcon />,
  name: "Нотификации",
  title: "Нотификации",
  subMenu: [EmailGroups, SentEmails],
};
